import React, { useState } from "react";
import { captainTcCardService } from "../services/captainTcCardService";
import { toast } from "react-toastify";

function CaptainTcCardEditForm({ assignment, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    status: assignment.status || "active",
    notes: assignment.notes || "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await captainTcCardService.updateAssignment(assignment.id, formData);
      if (response.status) {
        toast.success("Assignment updated successfully.");
        onSuccess();
      } else {
        toast.error(response.message || "Failed to update assignment.");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Failed to update assignment");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" style={overlayStyle}>
      <div className="modal-content" style={modalStyle}>
        <h3>Edit Assignment #{assignment.id}</h3>
        <p><strong>Card No:</strong> {assignment.card_no}</p>
        <p><strong>Serial No:</strong> {assignment.serial_number}</p>
        <form onSubmit={handleSubmit} style={formStyle}>
          <div className="form-group" style={groupStyle}>
            <label>Status</label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              style={inputStyle}
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
          
          <div className="form-group" style={groupStyle}>
            <label>Notes</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              style={{ ...inputStyle, minHeight: "80px" }}
             maxLength={65535} />
          </div>

          <div className="modal-actions" style={actionsStyle}>
            <button type="button" onClick={onClose} style={cancelBtnStyle} disabled={loading}>
              Cancel
            </button>
            <button type="submit" style={submitBtnStyle} disabled={loading}>
              {loading ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000
};
const modalStyle = {
  backgroundColor: "#fff", padding: "30px", borderRadius: "8px", width: "400px", maxWidth: "90%"
};
const formStyle = { display: "flex", flexDirection: "column", gap: "15px", marginTop: "20px" };
const groupStyle = { display: "flex", flexDirection: "column", gap: "5px" };
const inputStyle = { padding: "10px", border: "1px solid #ccc", borderRadius: "4px" };
const actionsStyle = { display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "10px" };
const btnBase = { padding: "10px 20px", border: "none", borderRadius: "4px", cursor: "pointer" };
const cancelBtnStyle = { ...btnBase, backgroundColor: "#f1f1f1", color: "#333" };
const submitBtnStyle = { ...btnBase, backgroundColor: "#1d4ed8", color: "#fff" };

export default CaptainTcCardEditForm;
